// Hérisson mascotte — uses the official transparent hedgehog PNG asset
import React from "react";
import hedgehogUrl from "@/assets/herisson-seul.png";

export default function HedgehogMascot({ size = 140, className = "", style = {} }) {
  return (
    <img
      src={hedgehogUrl}
      alt="Hérisson"
      width={size}
      height={Math.round(size * 0.85)}
      style={{ width: size, height: "auto", display: "block", objectFit: "contain", ...style }}
      className={className}
      draggable={false}
    />
  );
}
